import { ListPage } from '../features/accounts/list-page'

/**
 * /members - list view for the Member Management module.
 *
 * The feature directory is still `features/accounts/` and the types are still
 * `Account*`: those mirror the schema `sm2-account-service` publishes, and the
 * generated OpenAPI client is checked for drift in CI. The route and the labels
 * are what staff see, so those follow the module IA.
 *
 * The `BffErrorProvider` mount lives in `app.tsx` so the session-expired dialog
 * state is shared between `/members` and `/members/:id`. This page only
 * delegates to the list feature.
 */
export function MembersPage(): JSX.Element {
  return <ListPage />
}
